// @ts-nocheck
import { listStyles } from "@insite/content-library/Widgets/MyLists/MyListsList";

Object.assign(listStyles, {
    messageText: {
        ...listStyles.messageText,
        forwardAs: "h2",
    },
});
